import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { ScoreComponentProps } from '~/components/Score'

import Score from '~/components/Score'

const ScoreCellRenderer = ({ value }: ICellRendererParams<unknown, ScoreComponentProps>): ReactElement => {
  if (!value) return <div />

  const { isPercentage, total, type, value: score } = value

  return <Score isPercentage={isPercentage} total={total} type={type} value={score} />
}

export default ScoreCellRenderer
